import { createFileRoute, redirect } from '@tanstack/react-router';

// The Setup step is gone — input picking lives inside the Simulate view and
// drafts land there directly. This route survives only so old bookmarks and
// deep links keep working.
export const Route = createFileRoute('/_app/simops/$studyId/setup')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/simops/$studyId',
      params: { studyId: params.studyId },
      replace: true,
    });
  },
});
